
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/analsex",
      function () {
        return require("private-next-pages/sexleketoy/analsex/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/analsex"])
      });
    }
  